<div class="card">
  <p-table
    #dt
    [value]="dataItems"
    [(selection)]="dataItemsSelected"
    [dataKey]="tableSettings.dataKey"
    [rowHover]="true"
    [rows]="tableSettings.pageSize"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]="isLoading"
    [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [filterDelay]="0"
    [globalFilterFields]="globalFilterFields"
  >
    <ng-template #caption>
      <div
        *ngIf="tableSettings.showClear || tableSettings.showGlobalSearch"
        class="flex justify-between"
      >
        <div class="flex gap-4">
          <p-button
            *ngIf="tableSettings.showClear"
            [outlined]="true"
            icon="pi pi-filter-slash"
            [label]="'miscellaneous.action.clear' | translate"
            (click)="clear(dt)"
          />

          <p-button
            *ngIf="tableSettings.showRefresh"
            [outlined]="true"
            icon="pi pi-refresh"
            [label]="'miscellaneous.action.refresh' | translate"
            (click)="refresh()"
          />
        </div>
        <div *ngIf="tableSettings?.tableActions?.length">
          <ng-container *ngFor="let rowAction of tableSettings.tableActions">
            <p-button
              rounded
              [outlined]="true"
              [pTooltip]="rowAction?.tooltip ?? '' | translate"
              [icon]="rowAction.icon"
              (click)="onTableAction(rowAction.id)"
              [label]="rowAction?.label ?? '' | translate"
              class="ml-2"
            />
          </ng-container>
        </div>

        <div class="simplified-table__quick-filters-list">
          <ng-container *ngFor="let columnDef of columnDefs">
            <ng-container *ngIf="columnDef.featuredFilter">
              <!--<div
                *ngIf="columnDef.featuredFilter.type === 'TOGGLE'"
                class="simplified-table__quick-filter flex"
              >
                <p-columnFilter
                  [id]="getColumnFilterId(columnDef.column || '')"
                  [field]="columnDef.column || ''"
                  matchMode="in"
                  [showMenu]="false"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showApplyButton]="false"
                  [showClearButton]="false"
                  [showAddButton]="false"
                  class="flex items-center"
                >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-selectbutton
                      [(ngModel)]="
                        columnFilterModelsById[
                          getColumnFilterId(columnDef.column || '')
                        ]
                      "
                      [multiple]="true"
                      [options]="
                        columnFilterOptionsById[
                          getColumnFilterId(columnDef.column || '')
                        ]
                      "
                      optionLabel="label"
                      optionValue="value"
                      [allowEmpty]="true"
                      [unselectable]="false"
                      (onChange)="filter($event.value)"
                      class="w-full px-6 py-3"
                      styleClass="flex-1 w-full py-2.5"
                    >
                      <ng-template pTemplate="item" let-item>
                        <span class="text-sm">{{
                          "environments.info.tab." + item + ".label" | translate
                        }}</span>
                      </ng-template>
                    </p-selectbutton>
                  </ng-template>
                </p-columnFilter>
                <div class="flex items-center">
                  {{ columnDef.featuredFilter.filterLabel | translate }}
                  {{ getFeaturedFilterStr(columnDef) }}
                </div>
              </div> -->

              <div
                *ngIf="columnDef.featuredFilter.type === 'SELECT'"
                class="simplified-table__quick-filter flex"
              >
                <!-- <div
                  #columnFilterTest
                  (click)="testClick($event, columnDef.column || '')"
                > -->
                <p-columnFilter
                  [id]="getColumnFilterId(columnDef.column || '')"
                  [field]="columnDef.column || ''"
                  matchMode="in"
                  display="menu"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showApplyButton]="false"
                  [showClearButton]="false"
                  [showAddButton]="false"
                  class="flex items-center"
                >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-multiselect
                      [(ngModel)]="
                        columnFilterModelsById[
                          getColumnFilterId(columnDef.column || '')
                        ]
                      "
                      [options]="
                        columnFilterOptionsById[
                          getColumnFilterId(columnDef.column || '')
                        ]
                      "
                      optionLabel="label"
                      optionValue="value"
                      [showHeader]="false"
                      [showClear]="false"
                      (onChange)="filter($event.value)"
                      [placeholder]="
                        columnDef.featuredFilter.optionsPlaceholder | translate
                      "
                      styleClass="w-full"
                    >
                    </p-multiselect>
                  </ng-template>
                </p-columnFilter>
                <div class="flex items-center">
                  {{ columnDef.featuredFilter.filterLabel | translate }}
                  {{ getFeaturedFilterStr(columnDef) }}
                </div>
                <!--</div>-->
              </div>
            </ng-container>
          </ng-container>

          <!--<div class="simplified-table__quick-filter">
            <p-select
              [options]="quickFilterItems[0].items"
              [checkmark]="true"
              optionLabel="label"
              [showClear]="true"
              placeholder="Select a City"
              class="w-30"
            />
            <p-selectbutton
              [(ngModel)]="selectedEntityOption"
              [options]="entityOptions"
              aria-labelledby="basic"
              optionLabel="label"
              optionValue="value"
              [allowEmpty]="false"
              [unselectable]="true"
              (onChange)="changeSelect()"
            ></p-selectbutton>

            <p-columnFilter
              type="text"
              field="metadata.name"
              placeholder="Search by name"
              ariaLabel="Filter Name"
            ></p-columnFilter>

            <div
              #columnFilterTest
              (click)="testClick($event, '__complianceStatus')"
            >
              <p-columnFilter
                [id]="getColumnFilterId('__complianceStatus')"
                field="__complianceStatus"
                matchMode="in"
                display="menu"
                prefix="Another Text"
                [showMatchModes]="false"
                [showOperator]="false"
                [showApplyButton]="false"
                [showClearButton]="false"
                [showAddButton]="false"
              >
                <ng-template #filter let-value let-filter="filterCallback">
                  <p-multiselect
                    [(ngModel)]="
                      columnFilterModelsById[
                        getColumnFilterId('__complianceStatus')
                      ]
                    "
                    [options]="complianceStatusItems"
                    optionLabel="label"
                    optionValue="value"
                    [showHeader]="false"
                    [showClear]="true"
                    (onChange)="filter($event.value)"
                    placeholder="Select One"
                    styleClass="w-full"
                  >
                  </p-multiselect>
                </ng-template>
              </p-columnFilter>
              <p-columnFilter
                [id]="getColumnFilterId('__complianceStatus')"
                field="__complianceStatus"
                matchMode="equals"
                display="menu"
                prefix="Another Text"
                [showMatchModes]="false"
                [showOperator]="false"
                [showApplyButton]="false"
                [showClearButton]="false"
                [showAddButton]="false"
              >
                <ng-template #filter let-value let-filter="filterCallback">
                  <p-select
                    [(ngModel)]="filterStatus"
                    [options]="complianceStatusItems"
                    optionLabel="label"
                    optionValue="value"
                    [checkmark]="true"
                    [showClear]="true"
                    (onChange)="filter($event.value)"
                    placeholder="Select One"
                    styleClass="w-full"
                  >
                  </p-select>
                </ng-template>
              </p-columnFilter>
              <span>Status</span>
            </div>


          </div>-->
        </div>

        <p-iconField *ngIf="tableSettings.showGlobalSearch" iconPosition="left">
          <p-inputIcon>
            <i class="pi pi-search"></i>
          </p-inputIcon>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchValue"
            (input)="dt.filterGlobal(getEventValue($event), 'contains')"
            placeholder="Keyboard Search"
          />
        </p-iconField>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th *ngIf="tableSettings.selectableRows" style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>

        <th
          *ngFor="let columnDef of columnDefs"
          [pSortableColumn]="
            columnDef?.sorting?.overrideColumn ?? columnDef.column
          "
        >
          <div class="flex justify-between items-center">
            {{ columnDef.name | translate }}
            <p-sortIcon
              [field]="columnDef?.sorting?.overrideColumn ?? columnDef.column"
            />
            <!--<p-columnFilter
              type="text"
              field="name"
              display="menu"
              class="ml-auto"
            /> -->
          </div>
        </th>

        <!--<th pSortableColumn="name">
          <div class="flex justify-between items-center">
            Name
            <p-sortIcon field="name" />
            <p-columnFilter
              type="text"
              field="name"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="country.name">
          <div class="flex justify-between items-center">
            Country
            <p-sortIcon field="country.name" />
            <p-columnFilter
              type="text"
              field="country.name"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="representative.name">
          <div class="flex justify-between items-center">
            Agent
            <p-sortIcon field="representative.name" />
            <p-columnFilter
              field="representative"
              matchMode="in"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              class="ml-auto"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  [filter]="false"
                  [ngModel]="value"
                  [options]="representatives"
                  placeholder="Any"
                  (onChange)="filter($event.value)"
                  optionLabel="name"
                  class="w-full"
                >
                  <ng-template let-option #item>
                    <div class="flex items-center gap-2">
                      <img
                        [alt]="option.label"
                        src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                          option.image
                        }}"
                        style="width: 32px"
                      />
                      <span>{{ option.name }}</span>
                    </div>
                  </ng-template>
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="date">
          <div class="flex justify-between items-center">
            Date
            <p-sortIcon field="date" />
            <p-columnFilter
              type="date"
              field="date"
              display="menu"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="balance">
          <div class="flex justify-between items-center">
            Balance
            <p-sortIcon field="balance" />
            <p-columnFilter
              type="numeric"
              field="balance"
              display="menu"
              currency="USD"
              class="ml-auto"
            />
          </div>
        </th>
        <th pSortableColumn="status">
          <div class="flex justify-between items-center">
            Status
            <p-sortIcon field="status" />
            <p-columnFilter
              field="status"
              matchMode="equals"
              display="menu"
              class="ml-auto"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-dropdown
                  [ngModel]="value"
                  [options]="statuses"
                  (onChange)="filter($event.value)"
                  placeholder="Any"
                >
                  <ng-template let-option #item>
                    <p-tag
                      [value]="option.label"
                      [severity]="getSeverity(option.label)"
                    />
                  </ng-template>
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="activity">
          <div class="flex justify-between items-center">
            Activity
            <p-sortIcon field="activity" />
            <p-columnFilter
              field="activity"
              matchMode="between"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false"
              class="ml-auto"
            >
              <ng-template #filter let-filter="filterCallback">
                <p-slider
                  [(ngModel)]="activityValues"
                  [range]="true"
                  (onSlideEnd)="filter($event.values)"
                  styleClass="m-4"
                ></p-slider>
                <div class="flex items-center justify-between px-2">
                  <span>{{ activityValues[0] }}</span>
                  <span>{{ activityValues[1] }}</span>
                </div>
              </ng-template>
            </p-columnFilter>
          </div>
        </th> -->
        <th *ngIf="tableSettings.rowActions.length"></th>
      </tr>
    </ng-template>
    <ng-template #body let-dataItem>
      <tr class="p-selectable-row">
        <td *ngIf="tableSettings.selectableRows">
          <p-tableCheckbox [value]="dataItem" />
        </td>

        <ng-container *ngFor="let columnDef of columnDefs">
          @switch (columnDef.type) {
            @case ("text") {
              <td>{{ getColumnValue(dataItem, columnDef.column) }}</td>
            }
            @case ("text-sub") {
              <td>
                <div class="flex flex-col">
                  <div class="">
                    {{ getColumnValue(dataItem, columnDef.column) }}
                  </div>
                  <div class="text-muted-color">
                    {{ getColumnValue(dataItem, $any(columnDef).columnSub) }}
                  </div>
                </div>
              </td>
            }
            @case ("flag-fn") {
              <td>
                <ng-container
                  *ngIf="
                    getColumnValueFlagOption(dataItem, columnDef) as flagOption
                  "
                >
                  <p-tag
                    class="mr-3 mb-3 align-middle text-xs"
                    [severity]="$any(flagOption.severity || 'primary')"
                    [value]="flagOption.label | translate"
                  />
                </ng-container>
              </td>
            }
            @case ("date") {
              <td>
                {{
                  getColumnValue(dataItem, $any(columnDef).column)
                    | date: "mediumDate" // : "MM/dd/yyyy"
                }}
              </td>
            }
            @case ("time") {
              <td>
                {{
                  getColumnValue(dataItem, $any(columnDef).column)
                    | date: "mediumTime" // : "MM/dd/yyyy"
                }}
              </td>
            }

            @case ("boolean") {
              <td>
                <p-tag
                  *ngIf="
                    getColumnValue(
                      dataItem,
                      $any(columnDef).column,
                      $any(columnDef).expression
                    )
                  "
                  class="mr-3 mb-3 align-middle text-xs"
                  [severity]="$any($any(columnDef).trueSeverity || 'primary')"
                  [value]="
                    $any(columnDef).trueLabel || 'global.table.yes' | translate
                  "
                />
                <p-tag
                  *ngIf="
                    !getColumnValue(
                      dataItem,
                      $any(columnDef).column,
                      $any(columnDef).expression
                    )
                  "
                  class="mr-3 mb-3 align-middle text-xs"
                  [severity]="$any($any(columnDef).falseSeverity || 'danger')"
                  [value]="
                    $any(columnDef).falseLabel || 'global.table.no' | translate
                  "
                />
              </td>
            }

            @case ("user") {
              <td>
                <div
                  class="flex items-center gap-2 flex-row"
                  *ngIf="getUserEmailColumnValue(dataItem, columnDef)"
                >
                  <!-- <img
                    [alt]="customer.representative.name"
                    src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                customer.representative.image
              }}"
                    width="32"
                    style="vertical-align: middle"
                  /> -->
                  <p-avatar
                    [label]="
                      getUserAvatarInitials(
                        getColumnValue(dataItem, $any(columnDef).column),
                        getUserEmailColumnValue(dataItem, columnDef)
                      )
                    "
                    [ngStyle]="{
                      'background-color': getUserAvatarColor(
                        getColumnValue(dataItem, $any(columnDef).column),
                        getUserEmailColumnValue(dataItem, columnDef)
                      ),
                      color: '#ffffff',
                    }"
                    size="large"
                    shape="circle"
                    class="shrink-0 text-base"
                  />
                  <div class="flex flex-col grow">
                    <div class="flex flex-row justify-between">
                      <div
                        class="ml-1 align-middle max-w-60 text-ellipsis overflow-hidden"
                      >
                        {{ getColumnValue(dataItem, columnDef.column) }}
                      </div>
                      <p-tag
                        *ngIf="
                          $any(columnDef).userType &&
                          getColumnValue(dataItem, $any(columnDef).userType)
                        "
                        class="ml-3 align-middle text-xs"
                        [value]="
                          getColumnValue(dataItem, $any(columnDef).userType)
                        "
                      />
                    </div>

                    <span
                      [pTooltip]="getUserEmailColumnValue(dataItem, columnDef)"
                      tooltipPosition="top"
                      class="ml-1 align-middle text-muted-color text-xs max-w-60 text-ellipsis overflow-hidden"
                    >
                      {{ getUserEmailColumnValue(dataItem, columnDef) }}</span
                    >
                  </div>
                </div>
              </td>
            }
            @case ("flags") {
              <td>
                <ng-container
                  *ngFor="let columnFlag of $any(columnDef).columnFlags"
                >
                  <p-tag
                    *ngIf="
                      getColumnValue(
                        dataItem,
                        columnFlag.path,
                        columnFlag.expression
                      )
                    "
                    class="mr-3 mb-3 align-middle text-xs"
                    [severity]="$any(columnFlag.severity || 'primary')"
                    [value]="columnFlag.label | translate"
                  />
                </ng-container>
              </td>
            }
            @default {
              <td>{{ getColumnValue(dataItem, $any(columnDef).column) }}</td>
            }
          }
        </ng-container>

        <!--
        <td>
          {{ dataItem.name }}
        </td>
        <td>
          <div class="flex items-center gap-2">
            <img
              src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
              [class]="'flag flag-' + customer.country.code"
              style="width: 20px"
            />
            <span class="ml-1 align-middle">{{ customer.country.name }}</span>
          </div>
        </td>
        <td>
          <div class="flex items-center gap-2">
            <img
              [alt]="customer.representative.name"
              src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                customer.representative.image
              }}"
              width="32"
              style="vertical-align: middle"
            />
            <span class="ml-1 align-middle">{{
              customer.representative.name
            }}</span>
          </div>
        </td>
        <td>
          {{ customer.date | date: "MM/dd/yyyy" }}
        </td>
        <td>
          {{ customer.balance | currency: "USD" : "symbol" }}
        </td>
        <td>
          <p-tag
            [value]="customer.status"
            [severity]="getSeverity(customer.status)"
          />
        </td>
        <td>
          <p-progressBar [value]="customer.activity" [showValue]="false" />
        </td>
        <td style="text-align: center">
          <p-button
            rounded
            icon="pi pi-cog"
            (click)="actionCustomer(customer, 'settings')"
          />
        </td>-->
        <td
          *ngIf="tableSettings.rowActions.length > 0"
          style="text-align: right"
        >
          <ng-container *ngFor="let rowAction of tableSettings.rowActions">
            <p-button
              *ngIf="showRowAction(dataItem, rowAction)"
              rounded
              [pTooltip]="rowAction?.tooltip ?? '' | translate"
              [icon]="rowAction.icon"
              (click)="onRowAction(dataItem, rowAction.id)"
              [label]="rowAction?.label ?? '' | translate"
              class="ml-2"
            />
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="getTotalTdCount()">
          {{ tableSettings.emptyMessage | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
